<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Cadastrar novo chamado"
             col-md="col-md-5" offset="3">
    <template v-slot:modalContent>
      <form @submit.prevent="submitIncluirForm" enctype="multipart/form-data">
        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.imovel"
                    inputId="imovel"
                    :options="imoveis"
                    optionLabel="text"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                    :invalid="campoVazio.includes('imovel')"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="imovel">
                  <strong>Imóvel:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.tipo_dano"
                    inputId="tipo_dano"
                    :options="tipoDano"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    :invalid="campoVazio.includes('tipo_dano')"
                    @update:modelValue="getGarantias(dado.tipo_dano)"
                />
                <label for="tipo_dano">
                  <strong>Tipo de Dano:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.garantia"
                    :options="garantias"
                    optionLabel="label"
                    optionValue="value"
                    optionGroupLabel="label"
                    optionGroupChildren="items"
                    filter
                    style="width: 100%"
                    :panelStyle="{ width: '1200px' }"
                    panelClass="garantias-panel"
                    :invalid="campoVazio.includes('garantia')"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="garantia">
                  <strong>Problema:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="descricao" v-model="dado.descricao" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('descricao')"/>
                <label for="descricao">
                  <strong>Descrição do problema: <span class="text-danger font-bold">*</span>
                  </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <FileUpload
                  id="imagem"
                  :multiple="true"
                  accept="image/jpeg,image/jpg,image/png"
                  :maxFileSize="1000000"
                  :showUploadButton="false"
                  chooseLabel="Selecionar Imagem"
                  customUpload
                  @select="onSelect"
              >
                <template #empty>
                  <span>Arraste e solte as imagens aqui ou clique para selecionar.</span>
                </template>
              </FileUpload>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="descricao_img" v-model="imagem.descricao_img" size="small" style="width: 100%"/>
                <label for="descricao_img"><strong>Descrição da Imagem: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "CadastrarChamadoCrm",
  components: {
    BaseModal,
  },
  props: {
    clienteID: Number,
  },
  data() {
    return {
      dado: {
        cliente: this.clienteID,
        imovel: "",
        tipo_dano: "",
        garantia: "",
        descricao: "",
      },
      imagem: {
        img: [],
        descricao_img: "",
      },
      imoveis: [],
      garantias: [],
      campoVazio: [],
      tipoDano: [
        {label: 'ESTRUTURAL', value: 'E'},
        {label: 'OUTROS', value: 'O'}
      ],
    }
  },
  emits: ["fechar", "atualizarLista"],
  methods: {
    onSelect(event) {
      this.imagem.img = event.files;
    },
    async getImoveis() {
      const resultado = await apiRequest("GET", `${apiUrl.imoveis.createList}?cliente_id=${this.clienteID}`);
      if (resultado.success) {
        this.imoveis = resultado.data.results.map(i => ({
          value: i.id,
          text: i.descricao
        }));
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getGarantias(tipo_dano) {
      let imovel_id = this.dado.imovel
      let dados = {
        'imovel_id': imovel_id,
        'tipo_dano': tipo_dano,
      }

      const resultado = await apiRequest("POST", apiUrl.crm.garantias, dados);
      if (resultado.success) {
        const grupos = resultado.data.grupos;
        const itens = resultado.data.itens;

        this.garantias = grupos.map(grupo => ({
          label: grupo,
          items: itens
              .filter(item => item.elemento === grupo)
              .map(item => ({
                value: item.id,
                label: `${item.patologia} | Prazo: ${item.prazo}` + (item.status ? ` | Status: ${item.status}` : "")
              }))
        }));
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitIncluirForm() {
      const form = new FormData();

      form.append('cliente', this.dado.cliente);
      form.append('imovel', this.dado.imovel);
      form.append('tipo_dano', this.dado.tipo_dano);
      form.append('garantia', this.dado.garantia);
      form.append('descricao', this.dado.descricao);

      form.append('descricao_img', this.imagem.descricao_img);
      this.imagem.img.forEach((file) => {
        form.append('img', file);
      });

      const resultado = await fetch(apiUrl.crm.createList, {
        method: 'POST',
        credentials: 'include',
        body: form,
      });

      const data = await resultado.json();
      if (resultado.ok) {
        this.$emit("atualizarLista", data);
        this.$toastMessage("success", "Registro salvo com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(data);
        if (data && typeof data === "object") {
          for (const campo in data) {
            data[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getImoveis();
  }
}
</script>
